(() => {
  'use strict';
  const script = document.querySelector('script[data-nimall-personalized-bridge]');
  const main = document.getElementById('MainContent');
  if (!script || !main || !['AE', 'SA'].includes(script.dataset.market || '')) return;
  const currency = script.dataset.currency || '';
  if (!['AED', 'SAR'].includes(currency) || (script.dataset.market === 'AE' && currency !== 'AED')) return;
  const root = script.dataset.root || '/';
  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/.test(root)) return;
  const title = script.dataset.title || '';
  if (!title) return;
  const endpoint = 'https://account.nimall.com/api/customer-account/recommendations/interest/';
  const handlePattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  const placement = script.dataset.placement || 'home';
  if (!['home', 'discovery', 'pdp', 'cart'].includes(placement)) return;
  const currentHandle = placement === 'pdp' ? location.pathname.match(/\/products\/([a-z0-9]+(?:-[a-z0-9]+)*)\/?$/)?.[1] : null;
  if (placement === 'pdp' && (!currentHandle || currentHandle.length > 255)) return;
  const shelf = document.createElement('section');
  shelf.className = 'nimall-personalized-shelf';
  shelf.hidden = true;
  shelf.setAttribute('aria-label', title);
  shelf.dir = document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr';
  const heading = document.createElement('h2');
  heading.className = 'nimall-personalized-shelf__title';
  heading.textContent = title;
  const header = document.createElement('div');
  header.className = 'nimall-personalized-shelf__header';
  const preferencesLink = document.createElement('a');
  preferencesLink.className = 'nimall-personalized-shelf__preferences';
  preferencesLink.href = `https://account.nimall.com/customer-account/recommendations?market=${script.dataset.market}`;
  preferencesLink.textContent = document.documentElement.lang.startsWith('ar') ? 'إدارة الاهتمامات' : 'Manage interests';
  header.append(heading, preferencesLink);
  const grid = document.createElement('div');
  grid.className = 'nimall-personalized-shelf__grid';
  shelf.append(header, grid);
  main.append(shelf);
  let revision = 0;
  let controller = null;
  const clear = () => {
    revision += 1;
    if (controller) controller.abort();
    controller = null;
    shelf.hidden = true;
    grid.replaceChildren();
  };
  async function refresh() {
    clear();
    if (document.hidden) return;
    const current = revision;
    controller = new AbortController();
    const signal = controller.signal;
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    const surface = mobile ? 'wap' : 'web';
    const excluded = new Set(currentHandle ? [currentHandle] : []);
    const parameters = new URLSearchParams({ placement, market: script.dataset.market, currency });
    if (currentHandle) parameters.set('context', currentHandle);
    // Read the public session cart only. No account identifiers, activity writes or telemetry.
    const cartController = controller;
    const cartTimeout = setTimeout(() => cartController.abort(), 5000);
    try {
      const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', signal });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      if (!Array.isArray(cart.items) || cart.items.length > 50) return;
      for (const item of cart.items) {
        if (typeof item.handle !== 'string' || !handlePattern.test(item.handle) || item.handle.length > 255) return;
        excluded.add(item.handle);
      }
    } catch { return; } finally { clearTimeout(cartTimeout); }
    if (current !== revision || signal.aborted) return;
    for (const handle of excluded) parameters.append('exclude', handle);
    let feed;
    try {
      const activeController = controller;
      const timeout = setTimeout(() => activeController.abort(), 10000);
      try {
        const response = await fetch(`${endpoint}${surface}/feed?${parameters}`, {
          mode: 'cors', credentials: 'include', cache: 'no-store', signal,
        });
        if (!response.ok) return;
        feed = await response.json();
      } finally { clearTimeout(timeout); }
    } catch { return; }
    if (current !== revision || signal.aborted || feed?.market !== script.dataset.market || feed?.currency !== currency
      || feed?.version !== 'buyer-interest-shopify-feed-v2' || !Array.isArray(feed.handles)) return;
    const handles = [...new Set(feed.handles.filter((value) =>
      typeof value === 'string' && handlePattern.test(value) && !excluded.has(value)))].slice(0, mobile ? 6 : 7);
    if (handles.length < 3) return;
    const cardController = controller;
    const cardTimeout = setTimeout(() => cardController.abort(), 5000);
    const cards = await Promise.all(handles.map(async (handle) => {
      try {
        const url = new URL(`${root}products/${handle}?section_id=nimall-personalized-card`, location.origin);
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal });
        if (!response.ok) return null;
        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const selector = mobile ? '[data-nimall-personalized-wap]' : '[data-nimall-personalized-web]';
        const wrapper = documentFragment.querySelector(selector);
        if (!wrapper || wrapper.getAttribute('data-product-handle') !== handle) return null;
        const card = wrapper.querySelector(mobile ? '.y01-product-card' : '.product');
        if (!card) return null;
        if (!mobile && !card.querySelector('.product-item')) return null;
        const link = card.querySelector('a[href*="/products/"]');
        if (!link || new URL(link.getAttribute('href'), location.origin).pathname.split('/').pop() !== handle) return null;
        return card;
      } catch { return null; }
    }));
    clearTimeout(cardTimeout);
    if (current !== revision || signal.aborted || document.hidden) return;
    const ready = cards.filter(Boolean);
    if (ready.length < 3) return;
    grid.replaceChildren(...ready);
    shelf.hidden = false;
  }
  document.addEventListener('visibilitychange', () => { if (document.hidden) clear(); else void refresh(); });
  window.addEventListener('focus', () => { void refresh(); });
  window.addEventListener('pagehide', clear);
  window.addEventListener('pageshow', () => { void refresh(); });
  document.addEventListener('cart:updated', () => { void refresh(); });
  void refresh();
})();
